import { DataServiceService } from 'src/app/services/data-service.service';
import { Payments } from './../../../model/Payments';
import { PaymentModel } from 'src/app/model/PaymentModel';
import { PaymentService } from './../../../services/payment.service';
import { AuthenticationService } from './../../../services/authentication.service';
import { AccountService } from 'src/app/services/account.service';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { UserDetailResult } from 'src/app/model/UserDetail';
import { UserModel } from 'src/app/model/UserModel';
import { Router } from '@angular/router';
import { WalletTransactionResult } from 'src/app/model/WalletTransaction';
import { modelGroupProvider } from '@angular/forms/src/directives/ng_model_group';
import { ActiveSessionsReqObj } from 'src/app/model/ApiRequests/ApiReqObj';
import { ToastrService } from 'ngx-toastr';
import { LteActiveSession } from 'src/app/model/LteActiveSessions';
import { ExportToCsv } from 'export-to-csv';

@Component({
  selector: 'app-e-wallet',
  templateUrl: './e-wallet.component.html',
  styleUrls: ['./e-wallet.component.css']
})
export class EWalletComponent implements OnInit {

  @ViewChild('datatable') datatable;
  transactionsDatatable: any;

  userdetail: UserDetailResult;
  currentUser: UserModel;
  walletbalance: number;
  reportData: Payments[] = [] as any;
  accType: string;
  searchValue = '';
  filterData = [] ;
  activeProducts: any = [] as any;
  startdate : string;
  enddate : string;
  selectedAccount : any;//: number = -1;
  config = {
    displayKey: "Display", //if objects array passed which key to be displayed defaults to description
    search: true,
    height: '180px'
  };
  options = {
    filename : 'selfcare portal report',
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true, 
    showTitle: true,
    title: 'E wallet transaction report',
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: false,
     headers: ['Date', 'Time', 'Description', 'Receipt No', 'Account Name', 'Subscriptions', 'Amount', 'Renewal Amount'] 
  };
  csvExporter:any;

  constructor(private router: Router, private accountService: AccountService, private authenticationService: AuthenticationService, private paymentService: PaymentService, private toastr: ToastrService, private dataService: DataServiceService) {
  
    


  this.csvExporter = new ExportToCsv(this.options);

    this.currentUser = this.authenticationService.getCurrentUser();
 

    if(this.currentUser.i_Account == "0")
    {
   let KycStatus :string = this.currentUser.KycStatus;
  
   if(KycStatus)
   {

    if(KycStatus== "Rejected" || KycStatus=="No Kyc")
    { 
      this.router.navigate(['/kyc']); 

    }
   }
    
    

 
    }


    this.dataService.currentAccountType.subscribe(acc => {
      this.accType = acc;

      this.PageLoad();
      this.fetchAccounts();

    });
  }

  async ngOnInit() {
    //await this.PageLoad();
    //await this.getTransactions(0, 3041, "01/01/2019", "09/09/2019");
  }

  Export(){
    let data = this.reportData.map(a=>{
      return <any>{
        Date : a.Date,
        Time : a.Time,
        Description : a.Description,
        ReceiptNo : a.ReceiptNo,
        AccountName : a.AccountName,
        Subscriptions : a.NoOfSubscriptions,
        Amount : a.Amount,
        RenewalAmount : a.CreditedAmount
      }
    });
    this.csvExporter.generateCsv(data);
  }
  async PageLoad() {

    let i_customer = parseInt(this.currentUser.i_Customer);

    if (!i_customer) {
      return;
    }

    let res = await this.accountService.getCustomerBalance(i_customer).toPromise();
    if (res.Result) {
      let bal = Math.round(res.Result);
      this.walletbalance = parseFloat(bal.toFixed(2));
    }
    this.walletbalance = this.walletbalance ? this.walletbalance : 0;
  }


  fundwallet() {
    this.router.navigateByUrl('/fundwallet');
  }

  async generateReport(){

    if(!this.selectedAccount){
      this.toastr.error("Select an account");
      return;
    }

    let acc = this.selectedAccount.i_account;
    console.log(this.selectedAccount.i_account);
    
    if(acc == 0){
      await this.getTransactions(0, this.currentUser.i_Customer, this.startdate,this.enddate);
      return;
    }

    if(!acc){
      this.toastr.error("Select an account");
      return;
    }    

    await this.getTransactions(acc, 0, this.startdate,this.enddate);

  }

  async getTransactions(i_account, i_customer, startdate, enddate ) {
    
    if(!startdate){
      startdate = new Date(-86400000000).toLocaleDateString();
    }
    if(!enddate){
      enddate = new Date(Date.now() + 86400000).toLocaleDateString();
      
    }
    
    let res: any;

    if (i_account) {
      res = await this.paymentService.LteGetAccountAllocations(i_account, startdate, enddate).toPromise();
    } 
    else {

      if(i_customer){
        res = await this.paymentService.LteGetCustomerAllocations(i_customer, startdate, enddate).toPromise();
      }
      
    }

    if (!res.Result) {
      this.reportData = [] as Payments[];
      return;
      
    }

    let response: WalletTransactionResult[] = res.Result;
    let allocations = response.filter(a => !a.DealerUserID);

    if (!allocations) { 
      this.reportData = [] as Payments[];
      return; 
    }

    let reportData = allocations.map(this.MapReportData);
    let total = allocations.reduce(this.calctotal,0);
    let totalCredited = allocations.reduce(this.calctotalCreditedAmount,0);
    let totalPayment : Payments = {} as Payments;

    totalPayment.Description = "Total"; totalPayment.Amount = total; totalPayment.CreditedAmount = totalCredited;
    totalPayment.Date="";totalPayment.Time="";totalPayment.ReceiptNo="";totalPayment.AccountName="";totalPayment.NoOfSubscriptions=0;

    reportData.push(totalPayment);
    this.reportData = reportData;


  }

  async fetchAccounts() {

    let activeSessionRequest: ActiveSessionsReqObj = {} as ActiveSessionsReqObj;
    activeSessionRequest.DownloadType = "ACC:GetDetail";
    var iAccount = parseInt(this.currentUser.i_Account);

    if (iAccount != 0) {
      //Ewallet is only for customer accounts
      this.toastr.error("Not available for individual accounts");
      this.router.navigateByUrl("/dashboard");
      return;
    }

    activeSessionRequest.i_customer = parseInt(this.currentUser.i_Customer);
    await this.setActiveSession(activeSessionRequest);
  }

  async setActiveSession(model: ActiveSessionsReqObj) {

    if (model) {
      let res = await this.accountService.getActiveSessionsFromLteHttp(model).toPromise();

      if (!res.Result) {
        this.toastr.error("An error occured, Couldn't get active sessions", "Error");
        return;
      }

      let activeSessions : any ;

      if (this.accType == "VOICE") {
        activeSessions = <LteActiveSession[]>res.Result.filter(a => a.Product.Name.toLowerCase().includes("voice"));
      } else {
        activeSessions = <LteActiveSession[]>res.Result.filter(a => !a.Product.Name.toLowerCase().includes("voice"));
      }

        
      this.activeProducts = activeSessions.map(a => {
        return <any>{
          AccountName: a.AccountName,
          ID: a.ID,
          i_account: a.i_account,
          Display: a.subscriber.FirstName ? a.subscriber.FirstName + ' - ' + a.ID : a.ID,
        }
      });

      this.activeProducts.unshift({AccountName: "",
      ID: "All account",
      i_account: 0,
      Display: "All accounts"});


    }
  }

  calctotal(total, num:WalletTransactionResult) {
    return total + num.Amount;
  }

  calctotalCreditedAmount(total, num:WalletTransactionResult) {
    return total + num.CreditedAmount;
  }

  MapReportData (model: WalletTransactionResult) {

    let desc = model.Description.split('-')[0];

    if (model.Description.includes('-')) {
      if (!isNaN(parseInt(desc)) && parseInt(desc) > 0) {
        desc = model.Description.split('-')[1];
      }
    }

    let mappedData: Payments = {} as Payments;
    mappedData.AccountName = model.PaymentAccount && model.PaymentAccount.length > 0 && model.PaymentAccount[0].ID ? model.PaymentAccount[0].ID.split('@')[0] : "";
    mappedData.Agent = model.CreatedBy;
    mappedData.Amount = model.Amount,
      mappedData.CreditedAmount = model.CreditedAmount ? model.CreditedAmount: 0,
      mappedData.CustomerName = `${model.Customer.i_customer} - ${model.Customer.FirstName ? model.Customer.FirstName : ""} ${model.Customer.LastName ? model.Customer.LastName : ""}`;
    mappedData.Time = new Date(model.CreatedDate).toLocaleTimeString(),
      mappedData.Description = desc,
      mappedData.i_customer = model.Customer.i_customer,
      mappedData.IsReversed = model.IsReversal ? "Yes" : "No",
      mappedData.Location = model.Location ? model.Location : "",
      mappedData.ProductName = model.Product && model.Product.Name ? model.Product.Name : "",
      mappedData.ReceiptNo = model.ReceiptNumber,
      mappedData.Category = model.Category,
      mappedData.Origin = model.Origin,
      mappedData.NoOfSubscriptions = model.NoofDays ? model.NoofDays : 1,
      mappedData.Date = new Date(model.CreatedDate).toLocaleDateString();

    return mappedData;

  }

}
